import React from 'react';
import { getId } from 'core/utils/analytics/sectionInfo';

/* Components */
import ButtonScrollingModalContent
  from 'org/modules/Modals/ButtonScrollingModal/components/ButtonScrollingModalContent';
import EmailUnsubscribeConfirmed from 'org/modules/EmailUnsubscribe/components/Confirmed';
import OnboardingAcquisition from 'org/modules/Onboarding/components/OnboardingAcquisition/OnboardingAcquisition';

/* Images */
import hiwShopOnlineImage from 'org/assets/images/hiw/hiw_home_shop_online.png';
import hiwEarnImage from 'org/assets/images/hiw/hiw_home_earn.png';
import hiwExploreImage from 'org/assets/images/hiw/hiw_home_explore.png';
import hiwShopInstoreImage from 'org/assets/images/hiw/hiw_home_shop_instore.png';
import hiwButtonImg from 'org/modules/Hiw/assets/button.png';
import loadingIndicatorGifInstore from 'org/assets/images/instore/loadingIndicatorInstore.gif';
import loadingIndicatorGif from 'org/assets/images/loadingIndicator.gif';
import homeButtonImage from 'org/assets/images/home_button.png';
import favoriteIconSvg from 'org/assets/images/icons/favorite.inline.svg';
import instoreIconImage from 'org/assets/images/instore/instoreIcon.svg';
import checkmarkWhiteImage from 'org/assets/images/icons/check_in_white.svg';
import { renderDirectMerchantDescription } from 'org/utils/directMerchantDescription';

// Safari Button Tutorial assets
import clientLogoImage from 'org/assets/images/logo.svg';
import setPermissionClientLogoImage from 'org/assets/images/logo_reverce.svg';
import animatedArrow from 'org/assets/safariButtonInstallTutorial/animatedArrow.svg';
import nonSafariIcon from 'org/assets/safariButtonInstallTutorial/nonSafari/nonSafariIcon.png';
import setPermissionClickImage from 'org/assets/safariButtonInstallTutorial/permissionSetting/clickText.gif';
import activationReminderImage from 'org/assets/safariButtonInstallTutorial/activationReminder/activationReminder.png';
import activationConfirmationVideo from
  'org/assets/safariButtonInstallTutorial/activationReminder/activationConfirmation.mp4';
import couponMagicImage from 'org/assets/safariButtonInstallTutorial/couponFinder/couponMagic.png';
import couponSuccessVideo from 'org/assets/safariButtonInstallTutorial/couponFinder/couponSuccess.mp4';
import priceMagicVideo from 'org/assets/safariButtonInstallTutorial/priceComparison/priceMagic.mp4';
import searchIntegrationVideo from 'org/assets/safariButtonInstallTutorial/searchIntegration/searchIntegration.mp4';
import storeOfferSettingsVideo from 'org/assets/safariButtonInstallTutorial/storeOfferSettings/storeOfferSettings.mp4';
import stickyFooterEmailImage from 'org/assets/images/stickyFooterEmail.png';

export const topStores = {
  h: {
    viewAllLinkCTAText: 'See all stores',
    api: {
      loggedOutParams: {
        content_group_id: 3384, // United VHP Top Stores 88x31
      },
    },
  },
  nr: {
    secTitle: 'Browse suggested stores',
    useCarousel: true,
    api: {
      params: {
        content_group_id: null,
        offer_tag: 'top-stores',
      },
    },
  },
  shopwifi: {
    shouldHideIncompleteRow: true,
  },
};

// content_group_id should be changed for a real one for this set of merchants
export const buyOnlinePickupInstore = {
  defaults: {
    api: {
      params: {
        content_group_id: 7482,
      },
    },
  },
};

export const topEarn = {
  defaults: {
    api: {
      params: {
        content_group_id: 6711,
      },
    },
  },
};

export const emailOptInSubscribeModal = {
  defaults: {
    useImageView: true,
    cancelText: 'No thanks. I don\'t like earning extra miles',
    earnType: 'miles',
    emailOptions: {
      email_news_optin: 1,
      email_odotw_optin: 1,
      email_solo_optin: 1,
      email_global_optout: 0,
    },
  },
};

export const forYou = {
  defaults: {
    heading: 'Limited-time bonus offers for you',
  },
};

export const emailOptInSuccessModal = {
  defaults: {
    earnType: 'bonus miles',
  },
};

export const seasonalFeatured = {
  defaults: {
    api: {
      params: {
        content_group_id: 5936,
      },
    },
  },
};

export const searchBar = {
  defaults: {
    getPlaceholder: () => ('Find a store or product'),
    shouldUseHybridSearch: true,
  },
};

export const searchModal = {
  defaults: {
    placeholderLanguage: '',
    shouldUseHybridSearch: true,
  },
};

export const hybridSearchForm = {
  defaults: {
    searchButtonClassName: 'mn_unitedIconSearch',
  },
};

export const quickSearch = {
  defaults: {
    directMerchantName: 'MileagePlus Partner',
  },
};

export const onboarding = {
  defaults: {
    customStepWeighting:
      [
        'welcome',
        'acquisition',
        'email',
        'favorites',
        'button',
        'mobileCongratulations',
      ],
    components: {
      Acquisition: OnboardingAcquisition,
    },
    checkShouldShowAcquisitionStep: (hasFCookieTrue, userIsIdentified, brandName) =>
      (hasFCookieTrue && userIsIdentified && brandName === 'united_cardholder'),
  },
};

export const onboardingButton = {
  defaults: {
    viewData: {
      getButtonHeader: (isMobileMQ) => (
        <>
          Activate award miles directly at store sites with
          the {isMobileMQ ? <>button</> : <>MileagePlus Shopping<sup>SM</sup> Button</>}
        </>
      ),
    },
  },
};

export const recentStores = {
  defaults: {
    viewData: {
      footerCTATitle: 'View all stores',
    },
    rebateOptions: {
      showAdditionalElevationPrefix: false,
      hideRebatePrefix: true,
      tiered: {
        showAdditionalElevationPrefix: false,
        hideRebatePrefix: true,
      },
    },
  },
};

export const similarStores = {
  defaults: {
    rebateOptions: {
      showAdditionalElevationPrefix: false,
      hideRebatePrefix: true,
      tiered: {
        showAdditionalElevationPrefix: false,
        hideRebatePrefix: true,
      },
    },
  },
};

export const featuredOffers502x272 = {
  sp: {
    api: {
      params: {
        content_group_id: 91,
      },
    },
  },
};

export const popularOffers = {
  defaults: {
    showMerchantBonusOffers300x250: true,
  },
  sp: {
    api: {
      params: {
        content_group_id: 11041,
      },
    },
  },
  fs: {
    api: {
      params: {
        content_group_id: 11039,
      },
    },
  },
};

export const offerTable = {
  sp: {
    api: {
      options: {
        sectionId: getId('all-offers'),
      },
    },
  },
  fs: {
    api: {
      params: {
        content_group_id: 4,
        skip_ad_suppressions: 1,
      },
      options: {
        sectionId: getId('free-shipping'),
      },
    },
  },
};

export const merchantExperience = {
  defaults: {
    api: {
      params: {
        with_instore: 1,
      },
    },
    termsTitle: 'Mileage terms:',
    directMerchantName: 'United MileagePlus Partner',
    directMerchantCTA: 'MileagePlus Partner',
    directMerchantDescription: renderDirectMerchantDescription(),
  },
};

export const storeRelatedMerchants = {
  defaults: {
    currency: 'miles',
  },
  pd: {
    useAddToFavorite: true,
  },
  me: {
    useAddToFavorite: true,
  },
};

export const sponsoredTextOffers = {
  bc: {
    api: {
      params: {
        content_type_id: 6,
        limit: 12,
      },
      options: {
        sectionId: getId('category-featured'),
      },
    },
  },
};

export const errorMessage = {
  defaults: {
    showErrorCodes: [404],
    errorMessages: {
      custom: {
        // Overrides all error code titles except the one passed as a data attribute via markup
        title: 'Well, this is awkward',
      },
      404: {
        message: 'We can\'t seem to find the page you\'re looking for. <br> Please try your request again later.',
      },
    },
  },
};

export const buttonLanding = {
  defaults: {
    viewOptions: {
      rewardsType: 'miles',
    },
    chromeMobileViewOptions: {
      title: 'Activate miles with the push of a button.',
      imgUrl: hiwButtonImg,
      description: 'Add the new MileagePlus Shopping button to your desktop browser.',
      compareSearchResultsType: 'mileage',
    },
  },
};

export const buttonUninstall = {
  defaults: {
    buttonUninstallIframeUrl: 'https://forms.office.com/r/CG28xJk7SC',
  },
};

export const buttonScrollingModal = {
  defaults: {
    components: {
      ButtonScrollingModalContent,
    },
  },
};

export const contactUsQuestions = {
  defaults: {
    questions: [
      {
        link: ({ siteUrl }) => `${siteUrl}/faq____.htm`,
        linkText: () => <>Frequently asked questions</>,
      },
      {
        link: ({ termsAndConditionsURL }) => termsAndConditionsURL,
        linkText: () => <>Terms and conditions of MileagePlus Shopping<sup>SM</sup></>,
      },
      {
        link: () => 'https://www.united.com/ual/en/US/fly/help/faq/my-account.html',
        linkText: () => <>General questions about my MileagePlus<sup>&reg;</sup> account</>,
      },
      {
        link: () => 'http://www.united.com/customerservice',
        linkText: () => <>General questions about United</>,
      },
    ],
  },
};

export const contactUsDashboard = {
  defaults: {
    useBase64CallBackURL: true,
    clientName: () => <>MileagePlus Shopping<sup>SM</sup></>,
    inquiry: {
      clientName: () => <>MileagePlus<sup>&reg;</sup></>,
      accountIdProd: '0013000000DEmkz',
      accountIdDev: '0016300000z8ATd',
      fields: {
        memberId: {
          inputName: 'clientMemberId',
          error: 'MileagePlus number is required',
        },
      },
    },
  },
};

export const extraRewardsDeals = {
  favorites: {
    secTitle: 'Extra miles deals from your favorites',
  },
};

export const instoreLinkLoader = {
  defaults: {
    animationLoader: {
      gif: loadingIndicatorGifInstore,
    },
    iconSuccessClassName: 'mn_unitedIconSuccess',
  },
};

export const instoreOfferModal = {
  defaults: {
    useBase64CallBackURL: true,
  },
};

export const instoreModal = {
  defaults: {
    useBase64CallBackURL: true,
  },
};

export const LoadingSpinner = {
  defaults: {
    animationLoader: {
      gif: loadingIndicatorGif,
    },
    iconSuccessClassName: 'mn_unitedIconSuccess',
  },
};

export const navBanner = {
  defaults: {
    bannerText: {
      button: {
        title: 'Earn miles with the push of a button',
        text: () => <>Get the new MileagePlus<sup>&reg;</sup> Shopping button and never miss out on miles.</>,
      },
      favorites: {
        title: 'Pick favorites',
        text: () => <>Select your favorite store and get emails about extra miles.</>,
        ctaTitle: 'Pick favorites',
      },
    },
  },
};

export const letterboxTOF = {
  defaults: {
    labelText: 'Extra',
    expiresPrefix: 'Valid thru ',
    getShouldUseRowMobileView: (isMobileMQ) => isMobileMQ,
  },
};

export const infoBar = {
  defaults: {
    dealOfTheWeek: {
      rebateOptions: {
        hideElevationCurrency: true,
        tiered: {
          hideElevationCurrency: true,
        },
      },
    },
    salesInfoBar: {
      rebateOptions: {
        hideElevationCurrency: true,
        tiered: {
          hideElevationCurrency: true,
        },
      },
    },
    infoBarAccordion: {
      shouldShowCtaButton: true,
    },
  },
};

export const merchantLogos = {
  defaults: {
  },
  acq: {
    api: {
      params: {
        limit: 9,
      },
    },
    useCarouselOnMediaQueriesOnly: ['XS', 'S'],
  },
  h: {
    apiParams: {
      limit: 8,
    },
    useCarouselOnMediaQueriesOnly: ['XS', 'S', 'M'],
  },
};

export const favoritesIcon = {
  defaults: {
    favoriteIconViewBox: '-1 0 42 35',
    FavoriteIconSvg: favoriteIconSvg,
  },
};

export const navSeasonalFlyout = {
  defaults: {
    tileLabel: 'Extra',
  },
};

export const howItWorks = {
  defaults: {
    hiwItems: [
      {
        image: hiwExploreImage,
        title: 'Explore',
        description: ({ storeCount }) => (
          <>Explore over {storeCount}+ stores, exclusive offers and bonus promotions, all in one place.</>
        ),
      },
      {
        image: hiwShopOnlineImage,
        title: 'Shop online',
        description: () => (
          <>Shop at the store site and check out as you normally would.</>
        ),
      },
      {
        image: hiwShopInstoreImage,
        title: 'Shop in store',
        description: () => (
          <>Link offers to your preferred card. Shop in store and pay with your linked card.</>
        ),
      },
      {
        image: hiwEarnImage,
        title: 'Earn',
        description: () => (
          <>
            Make a purchase and you'll earn miles for every dollar you spend
            in addition to those you earn with your card.
          </>
        ),
      },
    ],
  },
  /* CLPL-18656 Optimization test overwrites - start */
  h: {
    checkShouldUseCarousel: () => true,
    checkShouldUseInvertedView: () => true,
  },
  /* end */
};

export const personalizedTopOffers = {
  defaults: {
    viewAllLinkText: 'See all offers',
  },
};

export const testimonials = {
  defaults: {
    testimonialsCopy: [
      'The easiest way to earn miles I\'ve ever used.',
      'I love MileagePlus Shopping! It\'s so easy to use and a very good way to accumulate miles.',
      'Probably the single greatest, not widely known, ' +
      'way to earn airline miles from purchases you were going to make anyway!',
    ],
    checkShouldUseCarousel: (userIsIdentified, isMobileMQ) => (isMobileMQ ? false : !userIsIdentified),
    checkShouldShowIconInCarousel: (activeMQ) => (['XS', 'S'].includes(activeMQ)),
    checkShouldShowIconInSlide: (activeMQ) => (['M', 'L', 'XL', 'XXL'].includes(activeMQ)),
    getSectionTitle: (rewardCount, earnType) => (
      <>Join members earning {rewardCount} {earnType} on average annually</>
    ),
    carousel: {
      breakpoints: {
        l: { hasArrows: false },
      },
    },
  },
};

export const quickLinksTray = {
  defaults: {
    shouldShowFavoritesLink: false,
    shouldShowAllStoresLink: true,
    extraRewardsLanguage: 'Extra miles',
  },
};

export const emailOptInHome = {
  defaults: {
    emailOptionsSubscribe: {
      email_news_optin: 1,
      email_odotw_optin: 1,
      email_solo_optin: 1,
      email_global_optout: 0,
    },
    emailOptionsUnsubscribe: {
      email_news_optin: 0,
      email_odotw_optin: 0,
      email_solo_optin: 0,
      email_global_optout: 1,
    },
  },
};

export const homeButtonBenefits = {
  defaults: {
    buttonHeader: 'Earn miles with the push of a button',
    buttonDescription: 'Add the button browser extension for Chrome and you\'ll get notifications '
    + 'while shopping so you never forget to earn miles. Plus, you can:',
    buttonCopy: [
      'Automatically apply coupons at checkout',
      'Find new stores offering miles per dollar',
      'Get the lowest price with comparison features',
    ],
    buttonImage: homeButtonImage,
  },
};

export const featuredOffersLogo = {
  defaults: {
    getTitle: (storeCount) => (
      <>Earn at {storeCount}+ stores</>
    ),
  },
};

export const sweeps = {
  defaults: {
    getInactiveSweepsH2Text: () => 'MileagePlus Shopping isn\'t running a sweepstakes right now',
  },
};

export const hybridQuickSearch = {
  defaults: {
    instoreIconImage,
    directMerchantName: 'United MileagePlus Partner',
  },
};

export const favoritesLanding = {
  defaults: {
    favoritedMerchants: {
      iconClassName: 'mn_unitedIconHeart',
    },
  },
};

export const adBlockWarning = {
  defaults: {
    getWarningMessage: () => (
      `<div class='mn_adBlockAlertTitle'>Ad blocker alert</div><p>The use of ad blockers may prevent you from earning
       MileagePlus miles on your shopping. While shopping with MileagePlus Shopping, turn off any ad blockers or use a
       different browser to ensure you earn miles as expected.</p>`
    ),
  },
};

export const profile = {
  defaults: {
    profileDetailsConfig: {
      editLinkUrl: 'https://www.united.com/myaccount',
      programName: 'MileagePlus',
    },
    emailDetailsConfig: {
      getSubscribedText: () => <>You are currently opted-in to all MileagePlus Shopping<sup>SM</sup> emails.</>,
      getUnsubscribedText: () => <>You are currently opted out from MileagePlus Shopping<sup>SM</sup>.</>,
    },
    accountSnapshotConfig: {
      getUserInfoText: (userName) => (<>MileagePlus member: <span className="mn_memberValue">{userName}</span></>),
      getRegistrationDateText: (isMobileMQ, formattedCreateDate) => (
        isMobileMQ
          ?
            <>
              MileagePlus Shopping<sup>SM</sup> member <br />since:{' '}
              <span className="mn_memberValue">{formattedCreateDate}</span>
            </>
          :
            <>
              MileagePlus Shopping<sup>SM</sup> member since:{' '}
              <span className="mn_noWrap mn_memberValue">{formattedCreateDate}</span>
            </>
      ),
    },
  },
};

export const profileTransactionsTab = {
  defaults: {
    bonusLabel: 'Mileageplus Shopping',
  },
};

export const profileClickHistoryTab = {
  defaults: {
    checkShouldShowFullDisclaimer: (isMobileMQ) => !isMobileMQ,
    directMerchantInfo: {
      directMerchantMessage: 'This merchant does not offer United MileagePlus Shopping miles.',
      directMerchantTooltip: renderDirectMerchantDescription(),
      directMerchantLabel: 'United MileagePlus Partner',
    },
  },
};

export const safariButtonInstallTutorial = {
  defaults: {
    clientLogoImage,
    setPermissionClientLogoImage,
    animatedArrow,
    nonSafariIcon,
    getNonSafariHeader: () => 'This United Airlines MileagePlus Shopping button is for Safari.',
    setPermissionClickImage,
    setPermissionTextLong: 'Setting the permissions correctly allows the Button to check for miles earning '
    + 'opportunities and coupons whenever you visit a participating merchant site.',
    setPermissionTextShort: 'Shop with confidence, knowing you\'ll never miss out on earning miles!',
    installDescriptionTextShort: 'Ready to effortlessly save and earn miles while you shop?',
    getInstallDescriptionTextLong: () => ' Discover how the MileagePlus Shopping Button maximizes your miles-earning '
    + 'potential and savings with these tools.',
    activationReminderImage,
    activationConfirmationVideo,
    couponMagicImage,
    couponSuccessVideo,
    priceMagicVideo,
    searchIntegrationVideo,
    storeOfferSettingsVideo,
  },
};

export const merchantOffer = {
  defaults: {
    rebateOptions: {
      hideElevationCurrency: true,
      hideRebateCurrencyPrefixInWas: true,
      tiered: {
        hideRebateCurrencyPrefixInWas: true,
      },
    },
    getShouldRenderExtraPill: () => true,
    getExpiresText: () => ('Valid thru'),
    customCTAClassName: 'mn_button',
    dateFormat: 'MM/DD/YY',
  },
};

export const hybridProducts = {
  defaults: {
    extraLabel: 'Extra',
  },
};

export const productSearchResults = {
  defaults: {
    extraLabel: 'Extra',
  },
};

export const emailUnsubscribe = {
  defaults: {
    components: {
      Confirmed: EmailUnsubscribeConfirmed,
    },
  },
};

export const dntMobileWarning = {
  defaults: {
    iconClassName: 'mn_dntMobileWarningIcon',
  },
};

export const flipTile = {
  defaults: {
    rebateOptions: {
      showRebateInline: false,
      hideElevationCurrency: true,
      tiered: {
        hideElevationCurrency: true,
      },
    },
  },
};

export const navCategoryFlyout = {
  defaults: {
    rebateOptions: {
      showRebateInline: true,
      elevationOldValueSeparator: ',',
      hideRebatePrefix: true,
      rebateAdditionalPrefix: true,
      hideNewValuePrefix: true,
    },
  },
};

export const featuredDeals = {
  h: {
    getShouldUseFeaturedDealsRoundedView: () => (true),
  },
};

export const firstFavoriteModal = {
  defaults: {
    modalOptions: {
      shouldShowCloseButton: false,
    },
  },
};

export const trendingAndSeasonalOffers = {
  defaults: {
    getTitle: () => 'More ways to earn miles',
  },
};

export const bonusOffers = {
  defaults: {
    useAddToFavorite: true,
  },
};

export const onboardingFavorites = {
  defaults: {
    getOptInNoticeText: () => <>To turn alerts off, visit the My Account page.</>,
  },
};

export const onboardingMobileCongratulation = {
  defaults: {
    image: checkmarkWhiteImage,
  },
};

export const allInstoreOffers = {
  defaults: {
    instoreLabel: 'in-store',
    getInstoreSettingsLabel: () => <>Manage</>,
    getInstoreSortingLabel: () => <>Sort by</>,
  },
};

export const instoreManageCardsModal = {
  defaults: {
    getTitle: () => <>Your available cards</>,
  },
};

export const questions = {
  defaults: {
    getCollapsedAllText: () => <>Collapse all <span>&#xf106;</span></>,
    getExpandedAllText: () => <>Expand all <span>&#xf107;</span></>,
    getCollapsedIcon: () => <>&#xf106;</>,
    getExpandedIcon: () => <>&#xf107;</>,
  },
};

export const instoreHiw2 = {
  defaults: {
    getTitle: (earnType) => <>Earn {earnType} when you shop in store</>,
    getSubTitle: (earnType, isMobileMQ) => (
      !isMobileMQ && <>Link offers to your credit card and stop into stores near you to earn {earnType}.</>
    ),
    hiwItems: [
      {
        className: 'mn_itemFirst',
        title: '1. Browse',
        getContent: () => <>With thousands of locations, find an offer at a store near you.</>,
      },
      {
        className: 'mn_itemSecond',
        title: '2. Link',
        getContent: () => <>Link offers to your preferred Visa, Mastercard, or American Express card.</>,
      },
      {
        className: 'mn_itemThird',
        title: '3. Shop in store',
        getContent: () =>
          <>Pay with your linked card(s). For debit cards, run your transaction as credit at checkout.</>,
      },
    ],
  },
};

export const featuredInstoreOffers = {
  h: {
    getViewAllLinkTitle: () => 'View all in-store offers',
    getStaticTitle: (earnType) => <>Earn {earnType} when you shop <span className="mn_noWrap">in store</span></>,
  },
};

export const instoreLoginLink = {
  defaults: {
    useBase64CallBackURL: true,
    shouldIncludeHash: true,
  },
};

export const instoreAddNewCard = {
  defaults: {
    getTitle: (merchantName) => (merchantName ? `Add a card to link to ${merchantName}` : 'Add a card'),
  },
};

export const instoreCardTypes = {
  defaults: {
    cardNames: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
    },
  },
};

export const instoreEducationalTile = {
  defaults: {
    linkOffersInstoreLabel: 'in-store',
  },
};

export const meInstoreOffer = {
  defaults: {
    getUnlinkOfferButtonText: () => 'Unlink offer',
    disclaimerTitle: 'In-store terms and conditions:',
  },
};

export const onboardingSlideMessage = {
  defaults: {
    shouldUseSlideMessage: true,
  },
};

export const bonusHomeBanner = {
  defaults: {
    dateFormat: 'M/DD/YYYY',
  },
};

export const bonusButton = {
  defaults: {
    getClientName: () => <>MileagePlus Shopping<sup>SM</sup></>,
  },
};

export const stickyFooterVendor = {
  defaults: {
    stickyFooterButton: {
      buttonImage: hiwButtonImg,
      buttonCTA: 'Get the extension',
    },
    stickyFooterEmail: {
      emailImage: stickyFooterEmailImage,
      emailCongratualationsImage: stickyFooterEmailImage,
      emailCongratualationsCTA: 'Subscribe to email',
      subscribeOnEmailsOptions: {
        emailOptions: {
          email_news_optin: 1,
          email_odotw_optin: 1,
          email_solo_optin: 1,
          email_global_optout: 0,
        },
      },
    },
  },
};
